import React from 'react';
import { useIntl } from 'react-intl';

import { BaseModalProps } from '@/features/modal/types';
import { ModalLayout } from '@/features/modal/modals/ModalLayout';
import { Button } from '@/components/buttons/Button';
import { sendEventToAppWrapper } from '@/utils/app-wrapper-utils';
import { CustomWebToAppEvents } from '@/models/enum/app-wrapper.enum';
import { setBiometricChoice } from '@/utils/biometric-storage';

export interface BiometricOptInModalProps {
  email: string;
  password: string;
}

export const BiometricOptInModal = ({
  email,
  password,
  closeModal,
}: BiometricOptInModalProps & Pick<BaseModalProps, 'closeModal'>): JSX.Element => {
  const intl = useIntl();

  const handleEnable = () => {
    sendEventToAppWrapper(CustomWebToAppEvents.save_biometric_credentials, {
      email,
      password,
    });
    setBiometricChoice('enabled');
    closeModal();
  };

  const handleDecline = () => {
    setBiometricChoice('declined');
    closeModal();
  };

  return (
    <ModalLayout close={closeModal}>
      <div className="flex flex-col items-center gap-4 w-full max-w-xs">
        <svg
          width="56"
          height="56"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-blue-light"
        >
          <path d="M2 12C2 6.5 6.5 2 12 2a10 10 0 0 1 8 4" />
          <path d="M5 19.5C5.5 18 6 15 6 12c0-3.5 2.5-6 6-6 2 0 3.5 1 4.5 2.5" />
          <path d="M12 10c-1.1 0-2 .9-2 2 0 3-1 5.5-2.5 7.5" />
          <path d="M12 10c1.1 0 2 .9 2 2 0 2-.5 4-1.5 5.5" />
          <path d="M8.5 16.5c-.5 1.5-1 3-2 4.5" />
          <path d="M20 2v4h-4" />
        </svg>
        <h1 className="text-center text-lg font-bold">
          {intl.formatMessage({ id: 'biometric.opt-in.title' })}
        </h1>
        <p className="text-center text-gray-600">
          {intl.formatMessage({ id: 'biometric.opt-in.description' })}
        </p>
        <p className="text-center text-gray-400 text-sm">
          {intl.formatMessage({ id: 'biometric.opt-in.description.security' })}
        </p>
        <div className="flex flex-col gap-3 mt-2 w-full">
          <Button
            btnType="primary"
            text={intl.formatMessage({ id: 'biometric.opt-in.enable' })}
            onClickHandler={handleEnable}
          />
          <Button
            btnType="outline"
            text={intl.formatMessage({ id: 'biometric.opt-in.not-now' })}
            onClickHandler={handleDecline}
          />
        </div>
      </div>
    </ModalLayout>
  );
};
